<template>
  <button
    type="button"
    class="favorite-btn"
    :class="{ active: favorited }"
    :disabled="disabled"
    :aria-label="ariaLabel"
    :aria-pressed="favorited"
    @click="toggle"
  >
    <svg
      class="favorite-icon"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      aria-hidden="true"
    >
      <path
        v-if="favorited"
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
      />
      <path
        v-else
        d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
      />
    </svg>
  </button>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  favorited: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: 'В избранное',
  },
})

const emit = defineEmits(['favorite', 'unfavorite'])

const ariaLabel = computed(() => {
  return props.favorited ? `Убрать: ${props.label}` : props.label
})

function toggle() {
  if (props.favorited) {
    emit('unfavorite')
  } else {
    emit('favorite')
  }
}
</script>

<style scoped>
.favorite-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  padding: 0.5rem;
  background: #fff;
  color: #94a3b8;
  cursor: pointer;
  line-height: 0;
}

.favorite-btn:hover:not(:disabled) {
  background: #f8fafc;
  color: #64748b;
}

.favorite-btn.active {
  border-color: #fca5a5;
  background: #fff1f2;
  color: #e11d48;
}

.favorite-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.favorite-icon {
  display: block;
  fill: currentColor;
}
</style>
